"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Card = _interopRequireDefault(require("../../Card/Card"));
var _constants = require("../../constants");
var _Avatar = _interopRequireDefault(require("../../Avatar/Avatar"));
var _formatting = require("../../../helpers/formatting");
var FlexReviews = function FlexReviews(_ref) {
  var title = _ref.title,
    reviews = _ref.reviews;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "container max-width-lg"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "d8-u-ls-sm margin-bottom-lg text-center"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-l-auto-grid"
  }, reviews.map(function (review) {
    return /*#__PURE__*/_react["default"].createElement(_Card["default"], null, /*#__PURE__*/_react["default"].createElement("p", null, review.content.rendered), /*#__PURE__*/_react["default"].createElement("div", {
      className: "list--item__left flex margin-right-sm margin-top-sm"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "left margin-right-sm"
    }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
      avatarType: _constants.AVATAR_TYPES.CIRCLE,
      avatarSize: _constants.AVATAR_SIZES.SMALL,
      avatarColor: _constants.AVATAR_COLORS.PRIMARY,
      image: review.featured_image_src !== 'https://www.theyachtweek.com/wp-includes/images/media/default.png' && {
        url: review.featured_image_src,
        alt: review.title.rendered
      },
      initials: (0, _formatting.getInitialsFromName)(review.title.rendered && review.title.rendered.split(' ')[0], review.title.rendered && review.title.rendered.split(' ')[1])
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "right"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "margin-top-xs text-sm d8-u-color-contrast-high"
    }, review.title.rendered))));
  })));
};
FlexReviews.propTypes = {
  title: _propTypes["default"].string,
  reviews: _propTypes["default"].object
};
var _default = exports["default"] = FlexReviews;